import GLOBAL_URL from '../../url';
const USER_URL = `${GLOBAL_URL}/api/wavelight-backend/user`;
export default USER_URL;
